import { useBreakpoint } from '@hivebrite/design-system/Theme';

import getRailsType from 'hb-react/frontoffice/apps/LiveFeed/utils/getRailsType';
import FilePreviewModal from 'hb-react/shared/components/FilePreview';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

const AttachedImagePreviewModal = ({
  categories,
  comments,
  file,
  hideNextUrl,
  hidePreviousUrl,
  id,
  isOpen,
  likes,
  onCloseModal,
  onNext,
  onPrevious,
  onTogglePostLike,
  onUpdateItem,
  originalType,
  postContent,
  totalComments,
  type,
  user,
}) => {
  const breakpoint = useBreakpoint();
  const { flagEvNewsRevamp } = useFeatureFlag();
  const isSmallScreen = breakpoint === 's';

  const overwritingStyles = {
    margin: 'auto',
    maxWidth: isSmallScreen ? '100%' : '95vw',
    height: isSmallScreen ? '100vh' : 'auto',
  };

  const handleKeyNavigation = (keyCode) => {
    switch (keyCode) {
      case 39: // Right
        onNext?.();
        break;
      case 37: // Left
        onPrevious?.();
        break;
      default:
    }
  };

  const onCommentCallback = (newTotalComments, newComments) => {
    if (onUpdateItem) {
      const newItem = {
        id,
        type: originalType,
        comments: newComments,
        total_comments: newTotalComments,
      };

      onUpdateItem({ newItem, isItemPartial: true });
    }
  };

  return (
    <FilePreviewModal
      isOpen={isOpen}
      onCloseModal={onCloseModal}
      screenReadersCloseButtonText={s__(
        'LiveFeedAccessibility|Close preview of the images of the post',
      )}
      file={file}
      user={user}
      categories={categories}
      reactions={{
        type,
        railsType: getRailsType(type),
        comments,
        likes,
        id,
        isOpenInModal: true,
        onTogglePostLike,
        totalComments,
        initialLikes: likes,
        initialTotalComments: totalComments,
        displayCommentsByDefault: true,
        onCommentCallback,
      }}
      onSwipedLeft={onNext}
      onSwipedRight={onPrevious}
      overwritingStyles={overwritingStyles}
      postContent={postContent}
      content={{
        onKeyUp: handleKeyNavigation,
        prevImage: onPrevious,
        nextImage: onNext,
        hideNextUrl,
        hidePreviousUrl,
      }}
      withFullScreenModal={false}
    />
  );
};

export default AttachedImagePreviewModal;
